import DistroCenterService from "../../api/distro.service";
import { FilterNewData } from "@/utils";


const state = () => ({
  distroCenters: { data: [] },
  inventories: { data: [] },
  orders: { data: [] },
  stockCounts: { data: [] },
  singleDistro: {},
  singleStock: {},
});

const getters = {
  GetDistroCenters: (state) => state.distroCenters,
  GetNewDistroCenters: (state) => {
    let stateData = { ...state.distroCenters };
    const dataList = FilterNewData(stateData);
    return dataList;
  },
  GetSingleDistro: (state) => state.singleDistro,
  GetDistroInventories: (state) => state.inventories,
  GetDistrOrders: (state) => state.orders,
  GetStockCounts: (state) => state.stockCounts,
  GetSingleStock: (state) => state.singleStock,
};

const mutations = {
  SET_DISTROCENTER_STATE: (state, newData) => {
    state.distroCenters = { ...newData };
  },
  SET_SINGLE_DISTROCENTER: (state, newData) => {
    state.singleDistro = { ...newData };
  },
  SET_DISTRO_INVENTORIES: (state, newData) => {
    state.inventories = { ...newData };
  },
  SET_DISTRO_ORDERS: (state, newData) => {
    state.orders = { ...newData };
  },
  SET_DISTRO_STOCK_COUNTS: (state, newData) => {
    state.stockCounts = { ...newData };
  },
  SET_SINGLE_STOCK_COUNT: (state, newData) => {
    state.singleStock = { ...newData };
  },
};

const actions = {
	FetchDistroCenters: async (context, payload) => {
		const { authToken } = context.rootState.auth;
		try {
			const response = await DistroCenterService.distroCenters(
				authToken,
				payload
			);
			// console.log("fetchDistros", response);
			context.commit('SET_DISTROCENTER_STATE', response.data);
		} catch (error) {
			return error;
		}
	},
	CreateDistroCenter: async (context, payload) => {
		const { authToken } = context.rootState.auth;
		try {
			await DistroCenterService.createDistro(authToken, payload);
			// console.log("fetchDistros", response);
			const message = { code: 201, status: 'success' };
			return message;
		} catch (error) {
			const newError = {
				code: 400,
				status: 'error',
				message: error.response.data,
			};
			return newError;
		}
	},
	UpdateDistroCenter: async (context, payload) => {
		const { authToken } = context.rootState.auth;
		try {
			const res = await DistroCenterService.updateDistro(authToken, payload);
			// console.log("fetchDistros", response);
			if (res.status === 200) {
				const message = { code: 201, status: 'success' };
				return message;
			}
			return { code: 400, status: 'error', message: 'Error updating centre.' };
		} catch (error) {
			const newError = {
				code: 400,
				status: 'error',
				message: error.response.data,
			};
			return newError;
		}
	},
	FetchDistroInventories: async (context) => {
		const { authToken } = context.rootState.auth;
		const { agentProfile } = context.rootState.agentProfile;
		const { singleDistro } = context.rootState.distroCenter;
	

		const locationDetails = { locationId: singleDistro.locationId };
		const payload = {
			perPage: -1,
			searchBy: {
				clientId: agentProfile.clientId,
			},
		};
		try {
			const res = await DistroCenterService.inventories(authToken, payload);
			const bal = await DistroCenterService.balance(authToken, locationDetails);
			// console.log('products', res.data)
			let balances = bal.data;
			if (balances.length < 1) {
				res.data.data.forEach((product) => {
					product.balance = 0;
				});
			} else {
				// initial balance value for all products
				res.data.data.forEach((product) => {
					product.balance = 0;
				});
				// set available product quantity to the balance of inventory
				for (let i = 0; i < res.data.data.length; i++) {
					for (let j = 0; j < balances.length; j++) {
						// console.log(products.data[i]);
						if (res.data.data[i].id == balances[j].productId) {
							res.data.data[i].balance = balances[j].balance;
						}
					}
				}
				// console.log(res);
			}
			context.commit('SET_DISTRO_INVENTORIES', res.data);
			const message = { code: 201, status: 'success' };
			return message;
		} catch (error) {
			const newError = {
				code: 400,
				status: 'error',
				message: error.response.data,
			};
			return newError;
		}
	},
	FetchWareHouseInventories: async (context) => {
		const { authToken } = context.rootState.auth;
		const { agentProfile } = context.rootState.agentProfile;
    const { wareHouseInfo } = context.rootState.cachestore;
    
		const locationDetails = { locationId: wareHouseInfo.locationId };
		const payload = {
      perPage: -1,
      page:-1,
			searchBy: {
				clientId: agentProfile.clientId,
			},
		};
		try {
			const res = await DistroCenterService.inventories(authToken, payload);
			const bal = await DistroCenterService.balance(authToken, locationDetails);
			// console.log('products', res.data)
			let balances = bal.data;
			if (balances.length < 1) {
				res.data.data.forEach((product) => {
					product.balance = 0;
				});
			} else {
				// initial balance value for all products
				res.data.data.forEach((product) => {
					product.balance = 0;
				});
				// set available product quantity to the balance of inventory
				for (let i = 0; i < res.data.data.length; i++) {
					for (let j = 0; j < balances.length; j++) {
						// console.log(products.data[i]);
						if (res.data.data[i].id == balances[j].productId) {
							res.data.data[i].balance = balances[j].balance;
						}
					}
				}
				// console.log(res);
			}

			return res;
		} catch (error) {
			const newError = {
				code: 400,
				status: 'error',
				message: error.response.data,
			};
			return newError;
		}
	},
	FetchDistroOrders: async (context) => {
		const { authToken } = context.rootState.auth;
		// console.log("location | ",context.rootState.distroCenter.singleDistro)
		const payload = {
			limit: -1,
			locationId: context.rootState.distroCenter.singleDistro.locationId,
		};
		try {
			const res = await DistroCenterService.ordersBySubHub(authToken, payload);
			// console.log("res | ", res)
			if (res.status === 200) {
				context.commit('SET_DISTRO_ORDERS', res.data);
				const message = { code: 201, status: 'success' };
				return message;
			}
			return { code: 400, status: 'error', message: 'Error fetching orders.' };
		} catch (error) {
			const newError = {
				code: 400,
				status: 'error',
				message: error.response.data,
			};
			return newError;
		}
	},
	FetchStockCounts: async (context) => {
		const { authToken } = context.rootState.auth;
		const { singleDistro } = context.rootState.distroCenter;
		const payload = {
			limit: -1,
			locationId: singleDistro.locationId,
		};
		try {
			const res = await DistroCenterService.counts(authToken, payload);
			if (res.status === 200) {
				context.commit('SET_DISTRO_STOCK_COUNTS', res.data);
				const message = { code: 201, status: 'success' };
				return message;
			}
			return {
				code: 400,
				status: 'error',
				message: 'Error fetching stock counts.',
			};
		} catch (error) {
			const newError = {
				code: 400,
				status: 'error',
				message: error.response.data,
			};
			return newError;
		}
	},
	ConfirmInventoryRequest: async (context, payload) => {
		const { authToken } = context.rootState.auth;
		try {
			const response = await DistroCenterService.confirmRequest(
				authToken,
				payload
			);
			// console.log("fetchDistros", response);
			return response
		} catch (error) {
			return error;
		}
	},
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
